import { Component, OnInit } from '@angular/core';
import { FormConfirmDiscardComponent } from '@app/components/molecules/form-confirm-discard/form-confirm-discard.component';
import {
  CONFIRMATION_DIALOG_CONSTANTS,
  EMPTY_STRING,
  ERROR_LOG_MESSAGES,
  MODAL_CLASSES,
  SESSION_STORAGE_KEYS,
  SESSION_STORAGE_VALUES,
} from '@app/constants';
import { ModalService } from '@app/services/modal.service';
import { environment } from '@environments/environment';
import { addCookiesInfo } from '@utils/auth-validate';
import { AuthService } from 'app/services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  private delaySetTimeout: number = 500;
  loading: boolean = false;

  constructor(
    private auth: AuthService,
    private modalService: ModalService
  ) {}
  userEmail: string = '';

  ngOnInit(): void {
    if (
      sessionStorage.getItem(SESSION_STORAGE_KEYS.WRONG_ENVIRONMENT_DETECTED) ===
      SESSION_STORAGE_VALUES.TRUE
    ) {
      sessionStorage.removeItem(SESSION_STORAGE_KEYS.WRONG_ENVIRONMENT_DETECTED);
      this.showEnvironmentMismatchModal();
    }
    this.userEmail = this.auth.getEmail() ?? EMPTY_STRING;
    if (sessionStorage.getItem(SESSION_STORAGE_KEYS.LOADING) === SESSION_STORAGE_VALUES.TRUE) {
      this.loading = true;
    }
    setTimeout(() => addCookiesInfo(), this.delaySetTimeout);
    this.statusOnboarding();
  }

  async handleLogin() {
    try {
      await this.auth.googleSocialSignIn();
    } catch (error) {
      console.error(ERROR_LOG_MESSAGES.GOOGLE_SIGNIN_ERROR, error);
    }
  }

  async statusOnboarding() {
    await this.auth.getEmail();
  }

  private showEnvironmentMismatchModal(): void {
    const redirectUrl = environment.productionFrontendUrl;
    this.modalService.loadComponent(
      FormConfirmDiscardComponent,
      {
        ...CONFIRMATION_DIALOG_CONSTANTS.ENVIRONMENT_MISMATCH_MODAL,
        onKeep: () => {
          window.location.href = redirectUrl;
        },
        onConfirm: () => {
          this.modalService.close();
        },
      },
      MODAL_CLASSES.SM_OVERFLOW_VISIBLE
    );

    this.modalService.updateHeader(CONFIRMATION_DIALOG_CONSTANTS.ENVIRONMENT_MISMATCH_MODAL.header);
    this.modalService.open();
  }
}
